<template>
    <div>
        <legend>Клиенты</legend>
        <dx-data-grid
                :show-borders="true"
                :data-source="dataSource"
                :remote-operations="true"
        >
            <dx-editing
                    :allow-updating="true"
                    :allow-deleting="true"
                    :allow-adding="true"
                    mode="row"
            />

            <dx-column
                    data-field="Reception"
                    caption="Приемный пункт"
            />
            <dx-column
                    data-field="Toro"
                    caption="ТОРО"
            />
            <dx-column
                    data-field="Fio"
                    caption="ФИО"
            />
            <dx-column
                    data-field="Payer"
                    caption="Плательщик"
            />

        </dx-data-grid>
<!--        Email: ""-->
<!--        Id: 78-->
<!--        Login: null-->
<!--        PartnerGroupId: 1-->
<!--        PartnerPriceListId: 43-->
<!--        PartnerTourId: 20-->
<!--        Password: null-->
<!--        PaymentTypeId: 1-->
<!--        Phone: ""-->
<!--        Phone2: ""-->
    </div>
</template>
<script>
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { DxColumn, DxDataGrid, DxEditing } from 'devextreme-vue/data-grid';
import { get } from '@/admin/services/api/http-utils';
import token from '@/admin/services/token';
const url = `${process.env.VUE_APP_API_HOST}admin/customer`;


export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      priceLists: [],
    };
  },
  // async mounted() {
  //   await this.fetchPriceList();
  // },
  // watch: {
  //   '$route.params.partnerGroupId': function () {
  //     this.fetchPriceList();
  //   }
  // },
  computed: {
    dataSource() {
      return createStore({
        key: 'Id',
        loadUrl: `${url}/list/${this.$route.params.partnerGroupId}`,
        insertUrl: `${url}/${this.$route.params.partnerGroupId}/insert`,
        updateUrl: `${url}/update`,
        deleteUrl: `${url}/delete`,
        onBeforeSend(operation, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`,
          };
        },
      });
    },
  },
  methods: {
    // async fetchPriceList() {
    //   const { data } = await get(`${url}/columns/${this.$route.params.partnerGroupId}`);
    //   this.priceLists = data;
    //   console.log(data)
    // },
  },
};
</script>
